import axios from 'axios'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IMenuModel, IMenuReorderRequest, IMenuTreeModel, UNASSIGNED_TREE} from './MenuModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const MENU_BASE_URL = `${API_URL}api/v1/definition/menu`

export function createMenu(menu: Omit<IMenuModel, 'id' | 'createdAt' | 'updatedAt' | 'children'>) {
  return axios.post<ApiResponse<IMenuModel>>(`${MENU_BASE_URL}/create`, menu)
}

export function updateMenu(
  menuId: string,
  menu: Omit<IMenuModel, 'id' | 'createdAt' | 'updatedAt' | 'children'>
) {
  return axios.patch<ApiResponse<IMenuModel>>(`${MENU_BASE_URL}/update/${menuId}`, menu)
}

export function deleteMenu(menuId: string) {
  return axios.delete<ApiResponse<void>>(`${MENU_BASE_URL}/delete/${menuId}`)
}

/** menuTreeId verilirse yalnızca o ağacın menüleri; UNASSIGNED_TREE ise ağaca bağlı olmayanlar */
export function loadMenus(menuTreeId?: string | null) {
  const params =
    menuTreeId === UNASSIGNED_TREE ? {unassigned: true} : menuTreeId ? {menuTreeId} : {}
  return axios.get<ApiResponse<IMenuModel[]>>(`${MENU_BASE_URL}/all`, {params})
}

export const MENU_TREE_BASE_URL = `${API_URL}api/v1/definition/menu-tree`

export function loadMenuTrees() {
  return axios.get<ApiResponse<IMenuTreeModel[]>>(`${MENU_TREE_BASE_URL}/all`)
}

export function createMenuTree(request: {name: string; description: string}) {
  return axios.post<ApiResponse<IMenuTreeModel>>(`${MENU_TREE_BASE_URL}/create`, request)
}

export function updateMenuTree(id: string, request: {name: string; description: string}) {
  return axios.patch<ApiResponse<IMenuTreeModel>>(`${MENU_TREE_BASE_URL}/update/${id}`, request)
}

export function deleteMenuTree(id: string) {
  return axios.delete<ApiResponse<void>>(`${MENU_TREE_BASE_URL}/delete/${id}`)
}

export function loadMenusByRole() {
  return axios.get<ApiResponse<IMenuModel[]>>(`${MENU_BASE_URL}/getMenusByRole`)
}

export function reorderMenus(items: IMenuReorderRequest[]) {
  return axios.post<ApiResponse<void>>(`${MENU_BASE_URL}/reorder`, items)
}
